<template>
<v-container pa-0>
  <v-layout  justify-center pa-0>
    <!-- <v-flex xs7 sm6 md5 lg4 xl3 class="pa-3"> -->
      
      <deviceInfo></deviceInfo>
      <!-- <TD style="text-align: right; vertical-align: top;">
        <outputBitrates v-if="inBitrate !== null" :groupTitle="inBitrate.title" :params="inputBitreitai()"></outputBitrates>
        <outputBitrates v-if="outBitrate !== null" :groupTitle="outBitrate.title" :params="outputBitreitai()"></outputBitrates>
      </TD> -->
    <!-- </v-flex > -->
    <!-- <TR>
      <TD COLSPAN="2" STYLE="padding-top: 20px;">
        <diagnostic></diagnostic>
      </TD>
    </TR> -->
  </v-layout >

</v-container>
</template>

<script>

import deviceInfo from './deviceInfo'

// import Vue from 'vue'

export default {
  name: 'mainPage',
  components: {
    deviceInfo
  },
  data () {
    return {
      mounted: false
    }
  },
  methods: {

  },
  computed: {

  },
  beforeMount: function () {
  },
   mounted: function() {
    this.mounted = true
  },
  beforeDestroy: function () {
    // this.mounted = false
    // this.$store.commit('clearStatusParams')
    // this.$store.commit('setActiveGroups', [])
  }
}
</script>


